import { render, staticRenderFns } from "./explain-result-card-footer.component.vue?vue&type=template&id=287ba1d4&scoped=true"
import script from "./explain-result-card-footer.component.vue?vue&type=script&lang=ts"
export * from "./explain-result-card-footer.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-result-card-footer.component.vue?vue&type=style&index=0&id=287ba1d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287ba1d4",
  null
  
)

export default component.exports